import { getColor, getColorShade, getSizeBy } from '../../../../../src/styled/utils';
import React from 'react';
import styled from 'styled-components';
import { Body2Styles } from '../../../typography';
const StyledWrapper = styled.div `
  ${Body2Styles}
  display: grid;
  grid-column-gap: ${getSizeBy(4)};
  grid-template-columns: auto 1fr;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  font-weight: 600;
  white-space: nowrap;
  text-align: start;
  vertical-align: middle;
  background-color: ${getColor('surface')};
`;
export const TableTitleValue = ({ title, value }) => (React.createElement(StyledWrapper, null,
    React.createElement("span", null, title),
    " ",
    value ? React.createElement("span", null, value) : undefined));
